export default __webpack_public_path__ + "static/media/mouse-down.2c3d79bd.ogg";